module.exports = __webpack_public_path__ + "img/georgia.2039306.webp";